import { requestAuthAdmin } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';
export const PLAZAS_PATH = '/api-admin/v1/plazas';
async function request(path, options, token, environment) {
  if (getSelectedEnvironment() !== environment) throw new Error('Plaza environment changed. Reload the selected environment.');
  const response = await requestAuthAdmin(path, options, token);
  if (response.status === 204) return { config_revision: response.headers.get('ETag')?.replace(/^"|"$/g, '') };
  let body;
  try { body = await response.json(); } catch { throw new Error(`Plaza response unavailable (${response.status})`); }
  if (!response.ok) {
    const error = new Error(body?.msg || body?.message || `Plaza request failed (${response.status})`);
    error.status = response.status;
    error.code = body?.code;
    throw error;
  }
  return body?.data;
}
export async function getPlazas(token, environment) {
  const data = await request(PLAZAS_PATH, { method: 'GET' }, token, environment);
  if (!Array.isArray(data?.items) || typeof data?.config_revision !== 'string') throw new Error('Invalid Plaza collection response');
  return data;
}
function headers(revision, operationId) {
  if (revision == null || revision === '') throw new Error('Missing Plaza revision. Reload before making changes.');
  if (!operationId) throw new Error('Missing Plaza operation ID');
  return { 'If-Match': `"${revision}"`, 'X-Operation-Id': operationId };
}
export function createPlaza(input, revision, operationId, token, environment) {
  return request(PLAZAS_PATH, { method: 'POST', headers: headers(revision, operationId), body: JSON.stringify(input) }, token, environment);
}
export function updatePlaza(id, input, revision, operationId, token, environment) {
  return request(`${PLAZAS_PATH}/${encodeURIComponent(id)}`, { method: 'PATCH', headers: headers(revision, operationId), body: JSON.stringify(input) }, token, environment);
}
export function deletePlaza(id, revision, operationId, token, environment) {
  return request(`${PLAZAS_PATH}/${encodeURIComponent(id)}`, { method: 'DELETE', headers: { ...headers(revision, operationId), 'X-Confirm-Plaza-Id': String(id) } }, token, environment);
}
